import { css } from 'styled-components';

const MenuContent = css`
  height: calc(100% - 60px);
   ${({ theme }) => theme.breakPoints.tablet} {
      z-index: 1;
      margin-left: 0px;
      width: 100%;
      position: absolute;
    }

   ${({ theme }) => theme.breakPoints.largeTablet} {
      top: 72px;
      z-index: 3;
      width: auto;
      position: relative;
      margin-left: 256px;
      height: calc(100vh - 79px);
    }
`;

export default MenuContent;
